export function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  return value as Record<string, unknown>
}

export function finiteNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function hasUsableBaseGeometry(decoded: unknown): boolean {
  const r = asRecord(decoded)
  const base = r ? (asRecord(r.base) ?? asRecord(r.Base)) : null

  if (!base) return false

  const width = finiteNumber(base.width ?? base.Width)
  const height = finiteNumber(base.height ?? base.Height)

  return width != null && height != null
}

export function hasPathCommands(decoded: unknown): boolean {
  const r = asRecord(decoded)
  const path = r ? (asRecord(r.path) ?? asRecord(r.Path)) : null

  if (!path) return false
  const commands = (path.commands ?? path.Commands) as unknown

  return Array.isArray(commands) && commands.length > 0
}
